export default __webpack_public_path__ + "static/media/TrashIcon.01865e0c.svg";